import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./lang/en.json";
import es from "./lang/es.json";
import pt from "./lang/pt.json";
import { THEME_CONFIG } from "../configs/AppConfig";

const resources = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
  pt: {
    translation: pt,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  lng: THEME_CONFIG.locale,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
